import React, { useEffect, useRef, useState } from "react";
import { Trans } from "@lingui/macro";
import * as styles from "./PhoneNumber.module.scss";
import { useGeolocation } from "src/utils/localization/geolocation/GeolocationContext";
import { useMediaQuery } from "react-responsive";
import classNames from "classnames";
import { Icon } from "@silversea-ssc/ui-components-react";

const PhoneNumber: React.FC = () => {
  const geolocation = useGeolocation();
  const { phone: phoneNumber, phoneDisclaimer } = geolocation;

  const canHover = useMediaQuery({
    query: "not all and (hover: none)"
  });
  const usePhoneLink = !phoneDisclaimer || (phoneDisclaimer && canHover);

  const [showPhonePopup, setShowPhonePopup] = useState(false);
  const disclaimerDivRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (e) => {
    if (
      usePhoneLink &&
      disclaimerDivRef.current &&
      !disclaimerDivRef.current.contains(e.target)
    ) {
      setShowPhonePopup(false);
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      {phoneNumber && (
        <div className={styles.phoneNumberContainer} ref={disclaimerDivRef}>
          <div className={styles.phoneNumber}>
            {usePhoneLink && (
              <a
                href={`tel:${phoneNumber}`}
                aria-label={`call ${phoneNumber}`}
                data-content-piece="phone"
              >
                {phoneDisclaimer && (
                  <div className={styles.phoneDisclaimer}>
                    {phoneDisclaimer}
                  </div>
                )}
                <Icon
                  name="phone"
                  padding="inline"
                  size="1x"
                  className={styles.phoneNumberIcon}
                  ariaHidden={true}
                />{" "}
                <span>{phoneNumber}</span>
              </a>
            )}

            {!usePhoneLink && (
              <React.Fragment>
                <button onClick={() => setShowPhonePopup(!showPhonePopup)}>
                  <Icon
                    name="phone"
                    padding="inline"
                    size="1x"
                    className={styles.phoneNumberIcon}
                    ariaHidden={true}
                  />{" "}
                  {phoneNumber}
                </button>
                {phoneDisclaimer && (
                  <div
                    className={classNames({
                      [styles.phoneDisclaimer]: true,
                      [styles.forcePhoneDisclaimerShow]: showPhonePopup
                    })}
                  >
                    {phoneDisclaimer}
                    <br />
                    <a
                      href={`tel:${phoneNumber}`}
                      aria-label={`call ${phoneNumber}`}
                      data-content-piece="phone"
                      className={styles.clickToCallButton}
                    >
                      <Trans>Click to call</Trans>
                    </a>
                  </div>
                )}
              </React.Fragment>
            )}
          </div>
          <div className={styles.phoneNumberAlt}>
            <Trans>or contact your travel agent</Trans>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default PhoneNumber;
